import { IWPNews } from "@/src/types";
import { graphql, useStaticQuery } from "gatsby";

export type INewsData = {
  allWpNews: {
    nodes: INews[];
  };
};

export type INews = {
  newsInfo: IWPNews;
  uri: string;
  title: string;
  date: string;
  modified: string;
};

const useNewsData = () => {
  const { allWpNews }: INewsData = useStaticQuery(graphql`
    {
      allWpNews(sort: { date: DESC }) {
        nodes {
          newsInfo {
            videoUrl
            contentTitle
            ingress
            wysiwygContent
            tag
          }
          uri
          title
          date(locale: "SV", formatString: "DD MMMM YYYY")
          modified(formatString: "D MMMM YYYY")
        }
      }
    }
  `);
  return allWpNews.nodes;
};
export default useNewsData;
